import {
  buildPopoverEntries,
  extractTextFromNode,
  normalizeText,
} from './Cmarkdowntable.helpers';
import type {
  CmarkdowntableCell,
  CmarkdowntablePopoverEntry,
} from './Cmarkdowntable.types';

export enum CmarkdowntablePopoverOpenAction {
  Close = 'close',
  Open = 'open',
}

interface ResolveCmarkdowntablePopoverOpenStateInput {
  activeRowIndex: number | null;
  headerCells: CmarkdowntableCell[];
  row: CmarkdowntableCell[];
  rowIndex: number;
}

type CmarkdowntablePopoverOpenState = {
  action: CmarkdowntablePopoverOpenAction.Close;
} | {
  action: CmarkdowntablePopoverOpenAction.Open;
  entries: CmarkdowntablePopoverEntry[];
  idValue: string;
};

export function resolveCmarkdowntablePopoverOpenState(
  input: ResolveCmarkdowntablePopoverOpenStateInput,
): CmarkdowntablePopoverOpenState {
  if (input.activeRowIndex === input.rowIndex) {
    return { action: CmarkdowntablePopoverOpenAction.Close };
  }

  const entries = buildPopoverEntries({
    headerCells: input.headerCells,
    row: input.row,
  });

  if (entries.length === 0) {
    return { action: CmarkdowntablePopoverOpenAction.Close };
  }

  return {
    action: CmarkdowntablePopoverOpenAction.Open,
    entries,
    idValue: resolvePopoverIdValue({
      row: input.row,
      rowIndex: input.rowIndex,
    }),
  };
}

function resolvePopoverIdValue(input: {
  row: CmarkdowntableCell[];
  rowIndex: number;
}): string {
  return normalizeText(extractTextFromNode(input.row[0]?.content))
    || `Row ${input.rowIndex + 1}`;
}
